import { useNavigate } from "react-router";
import { useUserActions } from "../../actions/user-actions";
import { useUserPreferences } from "../shared/user-preferences";
import { useStore } from "../../store";
import { useSettingsActions } from "../../actions/settings-actions";
import { confirmPersistedRedirectionUrl } from "../../utils/local-storage/redirection";

export const useApplicationSettingsHelpers = () => {
  const [state] = useStore();
  const navigate = useNavigate();
  const { persistCustomer, persistPreference } = useUserPreferences();
  const { resetUser, updateUserVirtualRole, updateUserDateFormat } = useUserActions();
  const { toggleUserPref } = useSettingsActions();

  const handleCustomerChanged = (customerId: string) => {
    persistCustomer(customerId);
    resetUser();
    confirmPersistedRedirectionUrl();
    navigate("/logged");
  };

  const handleVirtualRoleChanged = async (role: number | null) => {
    if (state.user) {
      await updateUserVirtualRole(state.user.id, role);
      resetUser();
      navigate("/logged");
    }
  };

  const handleUserPrefChanged = (prop: string, status: boolean) => {
    toggleUserPref(prop, status);
    persistPreference(prop, status);
  };

  const handleDateFormatChanged = async (format: string) => {
    if (state.user) {
      await updateUserDateFormat(state.user.id, format);
      resetUser();
      navigate("/logged");
    }
  };

  return {
    handleCustomerChanged,
    handleVirtualRoleChanged,
    handleUserPrefChanged,
    handleDateFormatChanged
  };
};
